import React, { PureComponent } from 'react';
import Highcharts from 'highcharts';
import {
    HighchartsChart, Chart, withHighcharts, XAxis, YAxis, Title, Legend, ColumnSeries, Tooltip
} from 'react-jsx-highcharts';

class ChartComponent extends PureComponent {

    render() {
        const plotOptions = {
            series: {
                stacking: 'normal'
            }
        };

        const style = {
            minWidth: '310px',
            maxWidth: '800px',
            height: '155px',
            margin: '0 auto'
        };

        const series = [{ name: "Retrasadas", data: [this.props.data.Retrasadas], color: "#ed1c24" },
        { name: "Tiempo Medio", data: [this.props.data.Tiempo_Medio], color: "#ffd55c" },
        { name: "A Tiempo", data: [this.props.data.A_Tiempo], color: "#66d097" }];

        const renderSeries = series.map((serie, index) => {
            return <ColumnSeries key={index} name={serie.name} data={serie.data} color={serie.color} />
        });

        return <div style={style}>
            <HighchartsChart plotOptions={plotOptions} oneToOne={true}>
                <Chart type='bar' height={155} inverted='true' />
                <Title></Title>
                <Legend reversed="true" />
                <XAxis categories={['Órdenes']} />
                <YAxis min='0' allowDecimals={false}>
                    <YAxis.Title>Estatus</YAxis.Title>
                    {renderSeries}
                </YAxis>
                <Tooltip />
            </HighchartsChart>
        </div>;
    }
}

export default withHighcharts(ChartComponent, Highcharts);